export const getQueryStringParams = query => (query
  ? (/^[?#]/.test(query) ? query.slice(1) : query)
    .split('&')
    .reduce((params, param) => {
      const [key, value] = param.split('=');
      params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
      return params;
    }, {})
  : {}
);

export const getQuery = locationUrl => (locationUrl.search ? getQueryStringParams(locationUrl.search) : null);

export const isIterable = (obj) => {
  if (obj == null) {
    return false;
  }
  return typeof obj[Symbol.iterator] === 'function';
};

export const isRoundInterval = (string) => {
  if (string && !Number.isNaN(string) && string.length === 6) {
    return true;
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/helpers/index.js